import { CacheService } from "./CacheService";

export class SessionCacheService {
  static disableCache = false;

  private static sessionCachePrefix = "session_";

  static has(key: string) {
    return CacheService.has(this.sessionCachePrefix + key);
  }

  static get<T>(key: string, value?: () => T, expiresAt?: Date) {
    return CacheService.get(
      this.sessionCachePrefix + key,
      value,
      expiresAt ?? CacheService.getDefaultExpiresAt(60 * 24)
    );
  }

  static async getAsync<T>(
    key: string,
    value: () => Promise<T>,
    expiresAt?: Date
  ): Promise<T> {
    return CacheService.getAsync(
      this.sessionCachePrefix + key,
      value,
      expiresAt ?? CacheService.getDefaultExpiresAt(60 * 24)
    );
  }

  static set<T>(key: string, value: T, expiresAt?: Date) {
    return CacheService.set(
      this.sessionCachePrefix + key,
      value,
      expiresAt ?? CacheService.getDefaultExpiresAt(60 * 24)
    );
  }

  static remove(key: string) {
    CacheService.remove(this.sessionCachePrefix + key);
  }

  /**
   * Clears all session cache entries
   */
  static clearSessionCache() {
    try {
      Object.keys(localStorage).forEach((key) => {
        if (key.startsWith(this.sessionCachePrefix)) CacheService.remove(key);
      });
    } catch (e) {
      // Just in case to prevent breaking the app since it's used on login page
      console.warn("SessionCacheService, clearSessionCache(), error", e);
    }
  }
}
